import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import UIActions from '../../ui/UIActions';
import { useAppDispatch } from '../../app/redux/useAppSelector';
import { gql } from '../../graphql/generated/gql';
import { usePostLayoutApi } from '../PostLayoutProvider';

const DELETE_REACTION_THREAD_MUTATION = gql(`
  mutation deleteReactionThread($id: ID!) {
    deleteThread(threadId: $id) {
      id
    }
  }
`);

const useDeleteReactionThread = () => {
  const dispatch = useAppDispatch();
  const [deleteReactionThread] = useMutation(DELETE_REACTION_THREAD_MUTATION);
  const { triggerMagneticWallCollapseAction } = usePostLayoutApi();

  return useCallback(
    (id: string) => {
      dispatch(
        UIActions.confirmModal({
          title: 'Delete reactions?',
          message: 'All reactions will be deleted.',
          confirmButtonText: 'Delete',
          onConfirm: () =>
            deleteReactionThread({ variables: { id } }).then(() =>
              triggerMagneticWallCollapseAction(),
            ),
        }),
      );
    },
    [dispatch, deleteReactionThread, triggerMagneticWallCollapseAction],
  );
};

export default useDeleteReactionThread;
